<template>
  <div class="message">
    <p class="dutch">Geen meetpunten gevonden in de buurt van deze locatie.</p>
    <p class="english">No measuring points found around this location.</p>
  </div>
</template>

<script>
export default {
  name: 'no-images-found'
}
</script>

<style scoped>

</style>
